export const LOCAL_STORAGE_SETTINGS = 'LOCAL_STORAGE_SETTINGS';
export const LOCAL_STORAGE_USER_DATA = 'LOCAL_STORAGE_USER_DATA';
export const LOCAL_STORAGE_USER_RECEIVED_NOTIFICATIONS = 'LOCAL_STORAGE_USER_RECEIVED_NOTIFICATIONS';
